import { Component, Input } from '@angular/core';
import { Transaction } from '../transactions.models';
import * as moment from 'moment';

@Component({
  standalone: false,
  selector: 'dsp-mobile-transaction-card',
  templateUrl: 'mobile-card.component.html',
  styleUrls: [ 'mobile-card.component.scss' ]
})
export class MobileCardComponent {
  @Input() public transaction: Transaction;

  // noinspection JSMethodCanBeStatic
  public formatDate(date: string, format = 'YYYY-MM-DD'): string {
    return moment.utc(date).format(format);
  }
}
